<template>
  <div class="cell-account">
    <pageHeader title="账号出售" />

    <div class="cell-form">
      <van-form @submit="onSubmit">
        <div class="gray-box"></div>
        <van-field
          readonly
          v-model="gameName"
          label="游戏名称"
          name="游戏名称"
          input-align="right"
          class="input-field"
        />
        <van-field
          readonly
          v-model="platName"
          label="游戏平台"
          name="游戏平台"
          input-align="right"
          class="input-field"
        >
          <template #right-icon>
            <img :src="platUrl" alt="" />
          </template>
        </van-field>
        <van-field
          readonly
          v-model="gameAccountNo"
          label="游戏账号"
          name="游戏账号"
          input-align="right"
          class="input-field"
        />

        <div class="gray-box"></div>

        <van-field
          v-model="password"
          type="password"
          label="登录密码"
          name="登录密码"
          placeholder="请输入登录密码"
          input-align="right"
          class="input-field"
          :rules="[{ required: true, message: '请输入登录密码' }]"
        />
        <van-field
          v-model="title"
          label="商品标题"
          name="商品标题"
          placeholder="请输入商品标题"
          input-align="right"
          class="input-field"
          :rules="[{ required: true, message: '请输入商品标题' }]"
        />
        <van-field
          v-model="gameAreaServer"
          label="游戏区服"
          name="游戏区服"
          placeholder="请输入游戏区服"
          input-align="right"
          class="input-field"
          :rules="[{ required: true, message: '请输入游戏区服' }]"
        />
        <van-field
          v-model="roleName"
          label="角色名称"
          name="角色名称"
          placeholder="请输入角色名称"
          input-align="right"
          class="input-field"
          :rules="[{ required: true, message: '请输入角色名称' }]"
        />
        <van-field
          readonly
          v-model="totalMoney"
          label="累计消费"
          name="累计消费"
          input-align="right"
          class="input-field"
        />
        <van-field
          v-model="sallPrice"
          label="商品价格"
          name="商品价格"
          placeholder="请输入商品价格(元)"
          input-align="right"
          class="input-field"
          :rules="[{ required: true, message: '请输入商品价格' }]"
        />
        <div class="gray-box"></div>
        <van-field name="uploader" label="" class="upload-field">
          <template #input>
            <van-uploader multiple :after-read="afterRead" :max-count="2" v-model="uploader" />
          </template>
          <template #label>
            <span>上传游戏截图<em>（上传0-5张图）</em></span>
          </template>
        </van-field>

        <van-button native-type="submit" class="submit-btn"
          >提交申请</van-button
        >
      </van-form>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
  },
  computed: {
    ...mapGetters(["uuid"]),
  },
  data() {
    return {
      totalMoney: "由审核客服填写",
      password: "",
      title: "",
      gameAreaServer: "",
      roleName: "",
      sallPrice: "",
      rechargeId: "",
      gameName: "",
      gameAccountNo: "",
      platName: "",
      platUrl: "",
      uploader: [],
      imgUrlList: []
    };
  },
  mounted() {
    this.formInit();
    
  },
  methods: {
    formInit() {
      const { gameName, id, platName, platUrl, gameAccountNo } =
        this.$route.query;
      this.rechargeId = id;
      (this.gameName = gameName), (this.gameAccountNo = gameAccountNo);
      (this.platName = platName), (this.platUrl = platUrl);
    },

    onSubmit(values) {
      this.applyTransGameAccount(values)
    },

    async applyTransGameAccount(info) {
      console.log(info, 'info')
      // const { uploader, title, gameAreaServer, password, roleName, sallPrice  } = info
      let imgUrl = this.imgUrlList.join(';')
      try {
        const { data } = await requestMethods(
          "/modules/accounttx/accountTx/applyTransGameAccount.htm",
          "post",
          {
            rechargeId: this.rechargeId,
            uuid: this.uuid,
            title: this.title, gameAreaServer: this.gameAreaServer, password: this.password, roleName: this.roleName, sallPrice: this.sallPrice, imgUrl
          }
        );
        this.$toast('申请成功！');
        this.$router.push({ path: '/tradeRecord', query: { pageTab: 0 } })
      } catch (err) {
        this.$toast(err.message);
      }
    },

    async getUploadAuth() {
      try {
        const { data } = await requestMethods(
          "http://47.111.22.43:8082/oss/getOssPolicy.html",
          "post",
          {
            type: "data/img/transaction",
            suffix: "png",
          }
        );
        return {
          ossInfo: data
        }
      } catch (err) {
        this.$toast(err.message);
      }
    },

    async afterRead(file) {
      const { ossInfo } = await this.getUploadAuth();
      file.status = 'uploading';
      file.message = '上传中...'
      if (file) {
        let formData = new FormData();
        formData.append("key", ossInfo.dir);
        formData.append("OSSAccessKeyId", ossInfo.accessid);
        formData.append("signature", ossInfo.signature);
        formData.append("policy", ossInfo.policy);
        formData.append("callback", ossInfo.callback);
        formData.append("success_action_status", "200");
        formData.append("name", file.name);
        formData.append("file", file);
        let xhr = new XMLHttpRequest();
        xhr.open("post", `${ossInfo.host}`, true);
        xhr.onload = () => {
          let res = xhr.responseText;
          if (res) {
            let backRes = JSON.parse(res);
            console.log(backRes);
            if(backRes.previewUrl) {
              this.imgUrlList.push(backRes.previewUrl)
              file.status = 'success';
              file.message = '上传成功';
              console.log(this.uploader)
            } else {
               file.status = 'failed';
                file.message = '上传失败';
            }
            // this.uploader.push({url: backRes.previewUrl});
          }
        };
        xhr.send(formData);
      }
    },
  },
};
</script>

<style lang="scss">
.cell-account {
  .cell-form {
    padding-bottom: 140px;
    .gray-box {
      width: 100%;
      height: 12px;
      background: #f7f8fa;
    }
    .input-field {
      height: 104px;
      line-height: 70px;

      .van-field__right-icon {
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
    .van-field__label {
      font-weight: 500;
      font-size: 28px;
      color: #333333;
    }

    .upload-field {
      display: block;

      .van-field__label {
        width: 100%;
        margin-bottom: 20px;

        em {
          font-weight: 400;
          font-size: 28px;
          color: #888888;
        }
      }
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 60px;
    left: 24px;
    width: 702px;
    height: 88px;
    background: #ff7a3e;
    border-radius: 44px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 32px;
    color: #ffffff;
    line-height: 88px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/cellAccount/index.vue